import styled from "@emotion/styled";
import {Button} from "@mui/material";

export const PureButton = styled.button`
	border: 0;
	padding: 0;
	margin: 0;
	background: none;
	cursor: pointer;
`;

const ButtonPrimaryBase = styled(Button)``;

ButtonPrimaryBase.defaultProps = {
	variant: "contained",
	sx: {
		transition: "opacity 1s",
		borderRadius: "100px",
		background: "#0048C7",
		color: "#FFF",
		fontWeight: "700",
		minHeight: "46px",
		minWidth: "300px",
		textTransform: "none",
	},
};

const ButtonPrimaryInvertBase = styled(Button)``;

ButtonPrimaryInvertBase.defaultProps = {
	variant: "contained",
	sx: {
		transition: "opacity 1s",
		borderRadius: "100px",
		background: "#FFF",
		color: "#0048C7",
		fontWeight: "700",
		minHeight: "46px",
		minWidth: "300px",
		textTransform: "none",
		border: "1px solid #0048C7",
		"&:hover": {
			color: "#fff",
		},
	},
};

const ButtonSecondaryBase = styled(ButtonPrimaryBase)``;

ButtonSecondaryBase.defaultProps = {
	color: "info",
	sx: {
		background: "#142845",
		color: "#68A3F8",
		borderRadius: "100px",
		fontWeight: "700",
		minHeight: "46px",
		minWidth: "300px",
		textTransform: "none",
		width: "100%",
	},
};

/**
 * Type casting is required because of MUI issue
 * https://github.com/mui/material-ui/issues/13921#issuecomment-484133463
 */
export const ButtonPrimary = ButtonPrimaryBase as typeof Button;

export const ButtonSecondary = ButtonSecondaryBase as typeof Button;

export const ButtonPrimaryInvert = ButtonPrimaryInvertBase as typeof Button;

export const ButtonPure = styled.button`
	padding: 0;
	margin: 0;
	outline: none;
	background: none;
	border: none;
	cursor: pointer;
`;
